module.exports = __webpack_public_path__ + "img/cutlery-icon.08710539.svg";